import { render } from "./AssetTypeList.vue?vue&type=template&id=5fa35180"
import script from "./AssetTypeList.vue?vue&type=script&lang=js"
export * from "./AssetTypeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__